import { render, staticRenderFns } from "./empower.vue?vue&type=template&id=224803b0&scoped=true"
import script from "./empower.vue?vue&type=script&lang=js"
export * from "./empower.vue?vue&type=script&lang=js"
import style0 from "./empower.vue?vue&type=style&index=0&id=224803b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224803b0",
  null
  
)

export default component.exports